import request from './request';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface UserDto {
  id: string;
  email: string | null;
  nickname: string;
  systemRole: string;
}

export interface AuthResponse {
  accessToken: string;
  expiresAt: string;
  user: UserDto;
}

export function login(data: LoginRequest) {
  return request.post<unknown, AuthResponse>('/api/admin/auth/login', data);
}
